<template>
  <div :id="data.id" class="bg-gray-lighten3 pt-10 md:py-14">
    <div class="container">
      <div class="rounded-lg bg-white px-6 py-14 md:px-14 xl:px-28">
        <div
          v-if="data.top"
          class="grid-cols-2 border-b-[1px] border-gray-lighten1 pb-11 md:grid md:pb-[72px]"
        >
          <UiSectionTitle
            v-if="data.top.title"
            :title="data.top.title"
            class="title mb-8 text-3xl uppercase leading-none text-slate"
          />

          <div
            v-if="data.top.files"
            class="flex flex-col gap-y-5 md:pl-[15%] lg:pl-[120px]"
          >
            <div v-for="(file, i) in data.top.files" :key="i">
              <UiLink
                :to="file.url"
                :download="file.filename"
                class="title relative block pl-10 text-md text-blue"
              >
                <span
                  class="absolute left-0 top-1/2 h-8 w-8 -translate-y-1/2 text-red-lighten1"
                >
                  <UiIcon icon="pdfFile" container-size></UiIcon>
                </span>

                <span class="leading-[1.8rem]" v-html="file.name" />
              </UiLink>
            </div>
          </div>
        </div>

        <div
          v-if="data.bottom"
          class="pt-10 md:grid md:grid-cols-2 md:pt-[72px]"
        >
          <div
            v-if="data.bottom.text"
            class="mb-8 text-sm !leading-[1.8rem] text-slate md:text-md lg:whitespace-pre-line"
            v-html="data.bottom.text"
          />

          <div
            v-if="data.bottom.downloadButton"
            class="md:pl-[15%] lg:pl-[120px]"
          >
            <UiLink
              :to="data.bottom.downloadButton.link"
              :target="data.bottom.downloadButton.target"
              :download="data.bottom.downloadButton.download"
              class="relative mb-4 inline-flex min-w-[211px] rounded-lg bg-gray-lighten3 py-4 pl-14 pr-4 md:mb-6"
            >
              <span
                class="absolute left-4 top-1/2 h-8 w-8 -translate-y-1/2 text-blue"
              >
                <UiIcon icon="download" container-size></UiIcon>
              </span>

              <span class="flex flex-col">
                <span
                  class="title mb-1 text-sm uppercase leading-none text-blue"
                  v-html="data.bottom.downloadButton.text"
                />

                <span
                  v-if="data.bottom.downloadButton.version"
                  class="text-[0.75rem] leading-4 text-slate"
                  v-html="data.bottom.downloadButton.version"
                />
              </span>
            </UiLink>

            <div
              v-if="data.bottom.icons && data.bottom.icons.length"
              class="flex gap-2"
            >
              <div
                v-for="(icon, i) in data.bottom.icons"
                :key="i"
                v-lazy-background="getAssetUrl(icon)"
                class="h-8 w-8 bg-contain bg-no-repeat"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
</script>
